/**
 * InterpretationBlock — approach summary. Renders the LLM's understanding of
 * how the student approached the problem. Hidden when no summary is present.
 *
 * The underlying `Interpretation` type also carries `identifiedSteps`, but
 * those duplicate the Step Analysis section rendered above and are not
 * shown here.
 */
import { LatexText } from '../../latex';
import type { Interpretation } from '@padcanvas/shared';

interface Props {
    interpretation: Interpretation | undefined;
}

export function InterpretationBlock({ interpretation }: Props) {
    const approachSummary = interpretation?.approachSummary;
    if (!approachSummary) return null;

    return (
        <section className="sol-section sol-interpretation">
            <div className="sol-interpretation-summary">
                <h3 className="sol-section-title">Approach Summary</h3>
                <p><LatexText text={approachSummary} /></p>
            </div>
        </section>
    );
}
